// Données communes aux exports CSV et Excel des participants par séance : colonnes (clé de ligne API
// → en-tête), statut de scan, aplatissement de plusieurs séances en une liste. Partagé par l'onglet
// Billetterie (équipe) et la page publique du client.

/**
 * Statut de scan d'un billet : « Oui » / « Non », ou « 1/3 » pour un billet de plusieurs entrées
 * partiellement scanné. `tone` pilote la couleur (page publique, cellules Excel).
 */
export const scanStatus = ({ scanne, quantite }) => {
  if (quantite > 1 && scanne > 0 && scanne < quantite) return { tone: 'partial', label: `${scanne}/${quantite}` };
  return scanne >= quantite ? { tone: 'yes', label: 'Oui' } : { tone: 'no', label: 'Non' };
};

export const SESSION_EXPORT_COLUMNS = [
  { key: 'nom', label: 'Nom' },
  { key: 'prenom', label: 'Prénom' },
  { key: 'email', label: 'Email' },
  { key: 'tarif', label: 'Tarif' },
  { key: 'quantite', label: 'Quantité' },
  { key: 'statut', label: 'Statut' },
  { key: 'scanne', label: 'Scanné', value: (row) => scanStatus(row).label },
  { key: 'codeBillet', label: 'Code billet' },
  { key: 'commande', label: 'Commande' },
  { key: 'dateCommande', label: 'Date de commande', value: (row) => (row.dateCommande ? new Date(row.dateCommande).toLocaleString('fr-FR') : '') },
];

// Export de plusieurs séances : une colonne « Séance » et « Début séance » en tête de chaque ligne.
export const ALL_SESSIONS_COLUMNS = [
  { key: 'seance', label: 'Séance' },
  { key: 'debutSeance', label: 'Début séance' },
  ...SESSION_EXPORT_COLUMNS,
];

/** Lignes de plusieurs séances (résultat de l'API : [{ session, rows }]) en une seule liste. */
export const flattenSessionRows = (sessions) =>
  sessions.flatMap(({ session, rows }) => rows.map((row) => ({ ...row, seance: session.nom, debutSeance: session.startDate })));

export const slug = (text) => String(text || '').trim().replace(/[^\p{L}\p{N}]+/gu, '_').replace(/^_|_$/g, '');
